<template>  
  <div>
    <v-layout>
      <v-flex md4 class="px-4">
        <h3>Años fiscales</h3>
			</v-flex>
<!--       <v-flex md5 class="px-4">
        <slot name="mid-header">
          
        </slot>
			</v-flex> -->
      <v-flex md3 class="px-4">
        <template v-if="myPermissions.includes(2)">
          <v-btn color="primary" @click="addYear" class="float-r">
            <v-icon>add</v-icon>
            <span>Agregar año fiscal</span>
          </v-btn>
        </template>
			</v-flex>
    </v-layout>
    <br>
		<v-layout>
			<v-flex md6>
        <v-data-table
          :headers="headers"
          :items="filteredRows"
          :options.sync="pagination"
          class="tablaT1"
		  :class="dark_t?'dark':''">
          <template v-slot:item="props">
            <tr>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon
									@click="askForDelete(props.item)"
									style="color:darkred"
									v-if="myPermissions.includes(2)"
									:disabled="props.item.current">delete</v-icon>
              </td>
              <td>
                <fs1-span>{{props.item.year}}</fs1-span>
              </td>
              <td>
                <fs1-span>{{props.item.current ? 'Sí':'No'}}</fs1-span>
              </td>
              <td :style="`background-color:${dark_t?'black':'white'}`">
                <v-icon
									@click="selectedItem = props.item; dialogEdit = true"
									v-if="myPermissions.includes(2)"
									:disabled="props.item.current">edit</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>
            <tr>
              <td :style="`background-color:${dark_t?'black':'white'}`"></td>
              <td colspan="2">
              <v-icon>warning</v-icon>
              Sin Información.
              </td>
              <td :style="`background-color:${dark_t?'black':'white'}`"></td>
            </tr>
          </template>
        </v-data-table>
			</v-flex>
		</v-layout>

		<v-dialog v-model="dialogAdd" width="400">
			<v-card class="pa-40 textAlignCenter">
				<h3>Año fiscal</h3>
				<div class="mt-40" style="text-align:left">
					<b>Año</b>
					<v-autocomplete
            clearable
            :class="!selectedItem.year && 'textEmpty'"
            placeholder=" Ingrese año"
            v-model="selectedItem.year"
            :items="filterYears"
            hide-details
            prepend-icon="edit" 
            hide-no-data
            hide-selected/>
				</div>
				<br>
				<div>
					<v-btn color="secondary" @click="dialogAdd = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="save">
						<v-icon class="mr-1">save</v-icon>
						<span>Guardar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
		<v-dialog v-model="dialogEdit" width="400">
			<v-card class="pa-40 textAlignCenter">
				<h3>Año fiscal {{selectedItem.year}}</h3>
				<div class="mt-40" style="text-align:left">
					<b>Vigente</b>
					<v-switch class="ma-0" v-model="selectedItem.current"/>
				</div>
				<br>
				<div>
					<v-btn color="secondary" @click="dialogEdit = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary" @click="dialogEdit = false;dialogWarning = true" :disabled="!selectedItem.current">
						<v-icon class="mr-1">save</v-icon>
						<span>Guardar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog v-model="dialogWarning" width="400">
			<v-card class="pa-40 textAlignCenter">
				<h3>Año fiscal {{selectedItem.year}}</h3>
				<div class="mt-40" style="text-align:left">
					La plataforma cambiará la forma de realizar los cálculos de solicitudes de evaluaciones ASI, haga click en <v-icon small>warning</v-icon><b>Aceptar</b> si desea continuar
				</div>
				<br>
				<div>
					<v-btn color="secondary" @click="dialogWarning = false">
						<v-icon>close</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="change">
						<v-icon class="mr-1">warning</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>

		<v-dialog persistent v-model="deleteDialog" width="400">
			<v-card class="pa-20 textAlignCenter">
				<h3>{{selectedItem.name}}</h3>
				<h4>¿Seguro desea eliminar el año fiscal "{{selectedItem.year}}"?</h4>
				<br>
				<div>
					<v-btn color="secondary" @click="deleteDialog = false">
						<v-icon>reply</v-icon>
						<span>Cancelar</span>
					</v-btn>
					<v-btn color="primary"  @click="deleteItem(selectedItem)">
						<v-icon>delete</v-icon>
						<span>Aceptar</span>
					</v-btn>
				</div>
			</v-card>
		</v-dialog>
  </div>	
</template>

<script>
import {  addFiscalYears,changeFiscalYear } from '@/requests/ac';
import SimpleCrud from '@/components/mixins/simpleCrud/SimpleCrud';
const thisYear = new Date().getFullYear();
import { setImpactedAreasValues } from '@/functions/general.js';
export default {
  mixins: [SimpleCrud],
  data() {
    return {
			dialogWarning:false,
			dialogEdit:false,
			dialogAdd:false,
      storeKey: 'fiscal_years',
      pagination: {/* sortDesc: true, sortBy: ['year'], */ page: 1, itemsPerPage: 5, totalItems: 0 },
    };
  },
  computed: {
		listImpactedAreas(){ return this.$store.getters.listImpactedAreas },
		ebits() { return this.$store.getters.ebits },
    add() { return addFiscalYears },
    edit() { return changeFiscalYear },
    defaultItem() { return JSON.parse(JSON.stringify({current:false}))},
    filteredRows() { 
			console.warn(this.rows);
      return this.rows;
    },
    years() {
      const ys = [];
      for (let i = (thisYear+10); i > 1990; i--) ys.push(i);
      return ys;
    },
    filterYears() {
      const ret = [];
      const selectedYears = this.filteredRows.map(y => y.year);
      if (selectedYears.length === 0) return this.years;

      return this.years.filter(y => !selectedYears.includes(y));
    },
    headers() {
      return [
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
				{ text: 'Año', sortable: true, value: 'year' },
				{ text: 'Vigente', sortable: true, value: 'current' },
				{ text: '', sortable: false, class: 'backgroundWhite width30px' },
      ];
    },
  },
  methods: {
		async change(){
			this.dialogWarning = false;
			this.setProgress({message: 'Guardando...', show:true});

			if(!await this.assignAccess()) {
				this.setProgress({show:false});
				this.getError('no se pudo obtener acceso')
				return;
			} // if

			const method = this.edit;
			method({selected_fiscal_year:this.selectedItem.year})
				.then(r => {
					this.setProgress({show:false});
					if (r.current) {
						this.rows.forEach(e => e.current = false);
						this.selectedItem.current = true;
						this.$store.dispatch('set', {key: 'current_fiscal_year', val: this.selectedItem});
						this.setSnackbar({message:'Guardado.',class:'success'});
						this.selectedlistImpactedAreas(this.selectedItem.year);
					} else {
						this.setSnackbar({message:'Ocurrió un problema.',class:'error'});
					}
				})
				.catch(e => this.getError(e))
		},
		addYear() {
			this.selectedItem = {...this.defaultItem};
			this.dialogAdd = true;
		},
    addToAList(item) {
			this.dialogAdd=false;
    },
    removeFromList(item) {
      
		},
    selectedlistImpactedAreas(selectedFiscalYear){
      setImpactedAreasValues(this.listImpactedAreas, this.ebits, selectedFiscalYear);
    },
  },
};
</script>
